/**
 * 1 - OTC On-ramp
 * 2 - OTC Off-ramp
 * 3 - Retail On-ramp
 * 4 - Retail Off-ramp
 * 5 - Retail NFT-checkout
 */
export enum TransactionTypeForFee {
  OTC_ON_RAMP = 1,
  OTC_OFF_RAMP,
  RETAIL_ON_RAMP,
  RETAIL_OFF_RAMP,
  RETAIL_NFT_CHECKOUT,
}

export enum TransactionFeeType {
  EXCLUDE = 0,
  INCLUDE = 1,
  MERCHANT = 2,
}
